<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/priceManage',title:'价格管理列表'},{title:'定价信息'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail14">
                                        <el-form :model="zy" label-position="right" ref="zy" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="物料型号" class="h-elformWrap-2" >
                                                <el-input placeholder="" v-model="zy.materialDescrition" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="物料编码" class="h-elformWrap-2" >
                                                <el-input placeholder="" v-model="zy.materialCode" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="zy.levelname" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="物料组"
                                                    prop="materialGroupCode"
                                                    :rules="[{ required: false, message: '请选择', trigger: 'blur'},]"
                                                    class="h-elformWrap-2">
                                                <brselectlazy category="YLMaterialGroup"
                                                              :v="zy.materialGroupCode==null?'空':zy.materialGroupCode"
                                                              v-model="zy.materialGroupCode==null?'空':zy.materialGroupCode"
                                                              disabled="disabled"></brselectlazy>
                                            </el-form-item>
                                            <el-form-item label="定价状态" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="zy.setprice"
                                                          disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理" class="h-elformWrap-2" prop="typeUserCode">
                                                <el-input placeholder="请输入工号" v-model="zy.typeUserCode" :v="zy.typeUserCode" oninput="value=value.replace(/[^\d]/g, '')"  @change="checkUser"></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号属性" class="h-elformWrap-2" prop="protype">
                                                <el-input v-model="zy.protype"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="毛利率" class="h-elformWrap-2" prop="gross" v-show="isShowChengbeng">
                                                <el-input v-model="zy.gross"  readonly ></el-input>
                                            </el-form-item>
                                            <el-form-item label="成本" class="h-elformWrap-2" prop="cost" v-show="isShowChengbeng">
                                                <el-input v-model="zy.cost"  readonly ></el-input>
                                            </el-form-item>
                                            <el-form-item label="含税单价" class="h-elformWrap-2" prop="unitPrice" v-show="isShowChengbeng">
                                                <el-input v-model="zy.unitPrice"  readonly ></el-input>
                                            </el-form-item>
                                            <el-form-item label="不含税单价" class="h-elformWrap-2" prop="unitSellingPrice" v-show="isShowChengbeng">
                                                <el-input v-model="zy.unitSellingPrice"  readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="驳回审批意见" class="h-elformWrap-2"
                                                          v-if="chongxintijiaoshow">
                                                <el-input v-model="zy.shenpiyijian" placeholder=""
                                                          disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2" prop="xiaoe">
                                                <brselect  category="xiaoe_jishu" :v="zy.xiaoe" v-model="zy.xiaoe"></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2" prop="jishu">
                                                <brselect category="xiaoe_jishu" :v="zy.jishu" v-model="zy.jishu"></brselect>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <el-select v-model="zy.factory" placeholder="请选择" >
                                                    <el-option
                                                        v-for="(item) in factorylist"
                                                        :key="item.code"
                                                        :label="item.code"
                                                        :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="市场分类" prop="marketType" class="h-elformWrap-2">
                                                <template>
                                                    <brselectlazy category="market_type" :v="zy.marketType" v-model="zy.marketType"  :disabled="!(this.$store.getters.hasRole('swyl_caiwujl'))"></brselectlazy>
                                                </template>
                                            </el-form-item>

                                            <el-form-item label="场景分类" class="h-elformWrap-2" prop="sceneCode">
                                                <el-select v-model="zy.sceneCode"  placeholder="请选择" style="width:100%;" @change="getchang"  :disabled="!(this.$store.getters.hasRole('swyl_caiwujl'))" >
                                                    <el-option v-for="item in sceneList" :key="item.sceneCode"
                                                               :label="item.sceneName" :value="item.sceneCode">
                                                    </el-option>
                                                </el-select>
                                             </el-form-item>


                                        </el-form>
                                    </div>
                                </div>
                            </div>
                           <div class="h-txtCenter h-mrt60">
                              <!--  <el-button class="h-btn h-bBtn h-bgblueQ2" @click="updateData()" v-if="!chongxintijiaoshow">确认修改-->

                                 <el-button v-if="this.zy.dataInstid" type="text" class="h-btn h-bBtn h-bgblueQ2" @click="chakanjindu(zy.dataInstid)">跟踪</el-button>

                            </div>
                        </div>
                    </div>
                    <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;" v-if="isOemProduct">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2"
                                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>采购价格</h1>
                                </div>
                            </div>
                            <el-table
                                    ref="multipleTable"
                                    :data="oemTableData"
                                    stripe
                                    style="width: 100%"
                                    :border="true">
                                <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                </el-table-column>
                                <el-table-column
                                        prop="productName"
                                        label="产品型号">
                                </el-table-column>
                                <el-table-column
                                        prop="productId"
                                        label="产品编码">
                                </el-table-column>
                                <el-table-column
                                        prop="unitPrice"
                                        label="采购价格">
                                </el-table-column>
                                <el-table-column
                                        prop="currency"
                                        label="币种">
                                    <template slot-scope="scope">
                                        {{scope.row.currency | dictname('YLCurrency')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="customerCode"
                                        label="供应商编码">
                                </el-table-column>
                                <el-table-column
                                        prop="customerName"
                                        label="供应商名称">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2"
                                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>定价信息</h1>
                                </div>
                            </div>
                            <el-table
                                    ref="multipleTable"
                                    @selection-change="handleSelectionChange"
                                    :data="tableData3"
                                    stripe
                                    style="width: 100%"
                                    :border="true">
                                <el-table-column
                                        type="selection"
                                        width="40"
                                        :label="all">
                                </el-table-column>
                                <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                </el-table-column>
                                <el-table-column
                                        prop="leixing"
                                        label="定价类型"
                                        width="100">
                                    <template slot-scope="scope">
										<div v-if="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)">
											<div v-if="scope.row.leixing == 0">外销</div>
											<div v-if="scope.row.leixing == 1">内销</div>
                      <div v-if="scope.row.leixing == 2">外贸</div>
										</div>
										<div v-else>
											<el-select class="h-tableInput" v-model="scope.row.leixing" placeholder="请选择"
											           @change="changejibiequyu(scope.row)"
											           style="width: 100%;">
											    <el-option
											            v-for="(item) in dingjialeixing"
											            :key="item.value"
											            :label="item.label"
											            :value="item.value">
											    </el-option>
											</el-select>
										</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jibiequyu"
                                        label="级别/区域"
                                        width="100">
                                    <template slot-scope="scope">
										<el-select class="h-tableInput" v-model="scope.row.jibie" placeholder="请选择"
													:class="{'ljj_selectdisblednone':scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)}"
												   :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"
												   v-if="(scope.row.leixing==0||scope.row.leixing=='0')" filterable>
											<el-option
													v-for="(item) in YlSalesAreawaioxiaolist"
													:key="item.code"
													:label="item.name"
													:value="item.code">
											</el-option>
										</el-select>
										<el-select class="h-tableInput" v-model="scope.row.jibie" placeholder="请选择"
													:class="{'ljj_selectdisblednone':scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)}"
												   :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"
												   v-if="(scope.row.leixing==1||scope.row.leixing=='1')" filterable>
											<el-option
													v-for="(item) in customergrouplist"
													:key="item.code"
													:label="item.name"
													:value="item.code">
											</el-option>
										</el-select>
                    <el-select class="h-tableInput" v-model="scope.row.jibie" placeholder="请选择"
                               :class="{'ljj_selectdisblednone':scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)}"
                               :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"
                               v-if="(scope.row.leixing==2||scope.row.leixing=='2')" filterable>
                      <el-option
                          v-for="(item) in YlSalesAreawaioxiaolist"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                      </el-option>
                    </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="bizhong"
                                        label="币种"
                                        min-width="160">
                                    <template slot-scope="scope">
                                        <el-select class="h-tableInput" v-model="scope.row.bizhong" style="width:100%"
                                                   :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"
												   :class="{'ljj_selectdisblednone':scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)}"
                                                   filterable>
                                            <el-option v-for="item in bizhongListops" :key="item.code"
                                                       :label="item.name" :value="item.code"
                                                       :disabled="scope.row.leixing==1 || scope.row.leixing==2">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jiage"
                                        label="价格"
                                        width="100">
                                    <template slot-scope="scope">
										<div style="text-align: right;" v-if="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)">
										    {{scope.row.jiage}}
										</div>
										<div v-else>
											<el-input class="h-tableInput" v-model="scope.row.jiage" placeholder="" type="number"
											  :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"></el-input>
										</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="isuse"
                                        label="是否可用"
                                        width="100">
                                    <template slot-scope="scope">
                                         {{scope.row.isuse|dictname('shifou_keyong')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="ispass"
                                        label="状态"
                                        width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.ispass|dictname('DINGJIA_ZHUANGTAI')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="cuname"
                                        label="维护人"
                                        width="180">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.cucode">
                                            {{scope.row.cuname}}【{{scope.row.cucode}}】
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="startdate"
                                        label="有效开始时间"
										width="120">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)">
                                            {{scope.row.startdate}}
                                        </div>
                                        <div v-else>
                                            <el-date-picker
													class="h-tableInput"
                                                    v-model="scope.row.startdate"
                                                    style="width: 100%;"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="开始日期"
                                                    @change="dateChange1(scope.row)">
                                            </el-date-picker>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="effectivedate"
                                        label="有效结束时间"
										width="120">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)">
                                            {{scope.row.effectivedate}}
                                        </div>
                                        <div v-else>
                                            <el-date-picker
													 class="h-tableInput"
                                                    v-model="scope.row.effectivedate"
                                                    style="width: 100%;"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="结束日期"
                                                     @change="dateChange2(scope.row)">
                                            </el-date-picker>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" fixed="right" width="200">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" class="h-tableLink h-btn"
                                                   @click="delPlan(scope.$index,scope.row)">删除
                                        </el-button>
                                        <el-button v-if="scope.row.instid" type="text" size="small" class="h-tableLink h-btn" @click="chakanjindu(scope.row.instid)">跟踪</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!--<div class="h-tableAdd" @click="add_dingjia">-->
                                <!--<a>新增定价</a>-->
                            <!--</div>-->
                            <div class="h-tableAdd" @click="add">
                                <a>新增一行</a>
                            </div>
                        </div>
                    </div>
                </div>
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>
            </div>
            <div class="h-txtCenter h-mrt60">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="quxiao">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="chongxintijiao" v-if="chongxintijiaoshow">重新提交
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="dingjiaanniu(0)" v-if="!chongxintijiaoshow">暂存
                </el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="dingjiaanniu(1)" v-if="!chongxintijiaoshow">确认提交
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        data() {
            let that = this
            return {
                //批量导入
                uploaddownexcelflag: false,
                isOemPrice: true,
                isOemProduct: false,
                //区域list
                YlSalesAreawaioxiaolist: [],
                //级别list
                customergrouplist: [],
                //币种
                bizhongListops: [],
                //产地
                factorylist:[],
                chongxintijiaoshow: false,
                //ywid
                ywid: null,
                //instid
                instid: null,
                showinstid: null,
                showhistory: false,
                //taskid
                taskid: null,
                YLCurrencyList: [],
                fanhuizancun: [],
                bianlianga: '',
                //要删除的
                yaoshanchude: [],
                //查询定价集合
                dingjiajihe: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //币种
                bizhonglist: [],
                //区域
                YlSalesArea: [],
                //前页转发内容
                chanpinneirong: {},
                //定价id
                dingjiaid: '',
                dingjialeixing: [
                  {
                    value: 2,
                    label: '外贸'
                  }, {
                    value: 1,
                    label: '内销'
                }, {
                    value: 0,
                    label: '外销'
                }],
                jibie: [{
                    value: '',
                    label: '--请选择--'
                },],
                quyu: [{
                    value: '',
                    label: '--请选择--'
                },],
                //配置集合
                configlist: {},
                bizhongop: [{
                    value: '',
                    label: '--请选择--'
                },],
                materialOemCode: '',
                all: "全部",
                formInline: {
                    names: '',
                    starttime: '',
                    endtime: '',
                    areaName: ''
                },
                day1:'',
                day2:'',
                options2: [],
                zy: {
                    typeUserCode:""
                },
                tableData3: [
                    {
                        leixing: '',
                        jibie: '',
                        bizhong: '',
                        jiage: '',
                        youxiaoqi: ['', ''],
                        effectivedate: '',
                        startdate: ''
                    }
                ],
                oemTableData: [],
                optionsCustomer: [],
                optionsAgent: [],
                userCarePlan: {},
                totalbizhong: '',
                totalbizhong2: '',
                totalbizhong3: "",
                totalbizhong4: "",
                rules: {
                    typeUserCode: [{required: true, message: '请填写型号经理工号', trigger: 'change'}],
                  /*  xiaoe: [{required: true, message: '请选择是否计入销额', trigger: 'change'}],
                    jishu: [{required: true, message: '请选择是否计入基数', trigger: 'change'}],*/
                    factory: [{required: true, message: '请选择产地', trigger: 'change'}]

                },
                sceneList:[],//场景
                isShowChengbeng:true,//是否展示成本信息
                isShouhService:false,//是否售后增值服务产品
                fwProdcut:{
                    productName:null,
                    productId:null,
                    currency:null,
                    unitPrice:null,
                    customerName:null,
                    customerCode:null,
                },
            }
        },
        mounted() {
        },
        created() {
            //海外区域
            this.YlSalesAreawaioxiaolist = this.$store.getters.dictlist("dj_foreign_area");
            //经销商级别
            this.customergrouplist = this.$store.getters.dictlist("customer_group");
            //产地
            this.factorylist = this.$store.getters.dictlist("factory");

            //当前角色 如果有一下角色不允许展示成本信息
            if(this.$store.getters.hasRole('swyl_xiaoshoujl_wx') ){
                this.isShowChengbeng = false;
            }


            this.bizhongjiazai();

            this.options2 = this.$store.getters.dicts["userCareType"];
            if(this.$route.query.serviceProductsType == '售后增值服务'){
                this.isShouhService = true;
            }
            if (this.$route.query) {
                //如果有驳回信息
                if (this.$route.query.ywid) {
                    this.chongxintijiaoshow = true;
                    //ywid
                    this.ywid = this.$route.query.ywid;
                    //instid
                    this.instid = this.$route.query.instid;
                    //taskid
                    this.taskid = this.$route.query.taskid;
                    var ywid = {
                        ywid: this.$route.query.ywid,
                    }
                    this.chazhaobohui(ywid);
                } else {
                    this.materialOemCode = this.$route.query.materialCode;
                    //前页信息
                    this.chanpinneirong = this.$router.history.current.query;
                    //物料号
                    this.dingjiaid = this.$router.history.current.query.materialCode;
                    //上头内容
                    this.zy = this.$router.history.current.query;
                    this.query(this.$router.history.current.query);
                    if (this.$route.query.protype == 'OEM' && this.$route.query.hid != 'ND1'&& this.$route.query.hid != 'KS1') {
                        this.isOemProduct = true;
                        this.chakanOemOrice();
                    }
                    this.selectPriceData(this.dingjiaid);
                }
            }
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/chanp/priceManage' && from.path == '/chanp/priceChange'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            //查看进度
            chakanjindu(q){
                this.showinstid = q;
                this.showhistory = true;
            },
            changeType(v) {
                if (v == '自产') {
                    //如果型号属性修改为自产 则将采购价格限制去除
                    this.isOemPrice = true;
                    //将采购价格表格隐藏
                    this.isOemProduct = false;
                } else {
                    //若是OEM则将采购价格表格显示
                    this.isOemProduct = true;
                    //并调用查询价格接口查看采购价格
                    this.chakanOemOrice();
                }
            },
            chakanOemOrice() {
                if(this.isShouhService){
                    ss.chanpin.checkCgprice(this.materialOemCode).then(rd => {
                        if(rd.f){
                            let data = rd.msg;
                            for(var i = 0;i<data.length;i++){
                                let cgProduct = data[i];
                                this.fwProdcut.productId = cgProduct.prodcode;
                                this.fwProdcut.productName = cgProduct.promodel;
                                this.fwProdcut.unitPrice = cgProduct.totalPrice;
                                this.fwProdcut.currency = cgProduct.currency;
                                this.fwProdcut.customerCode = cgProduct.supplierCode;
                                this.fwProdcut.customerName = cgProduct.supplierName;
                                this.oemTableData.push(this.fwProdcut)
                            }
                            console.log(this.oemTableData)
                        }
                    })
                }else {
                    ss.chanpin.selectProPrice(this.materialOemCode).then(rd => {
                        this.oemTableData = rd;
                        console.log("看看拿到啥了：",this.oemTableData);
                        if (rd.length == 0) {
                            this.isOemPrice = false;
                            this.$msg.msge("OEM产品请先联系采购经理维护采购价格后才可发起定价！");
                        }
                    })
                }
            },

            /**
             * 查询销额 基数，产地修改记录
             * */
            selectPriceData(materialCode) {
                ss.chanpin.selectPriceData(materialCode).then(rd => {
                    if(rd){
                        this.$set(this.zy, "dataInstid", rd.instid);
                    }

                })
            },
            add_dingjia(){

            },
            dateChange1(val) {
                var dd = val.startdate;
                dd = dd.replace(/-/g, '/')
                var date =  new Date(dd);
                this.day1 = date.getTime();
                if (this.day2 < this.day1) {
                    if (this.day2 == 0) {
                        return;
                    }
                    this.$msg.msge("结束日期不能在开始日期之前");
                    val.startdate = "";
                }
            },
            dateChange2(val) {
                var tt = val.effectivedate;
                tt = tt.replace(/-/g, '/')
                var date = new Date(tt);
                this.day2 = date.getTime()
                if (this.day2 < this.day1) {
                    this.$msg.msge("结束日期不能在开始日期之前");
                    val.effectivedate = "";
                }
            },
            //币种加载
            bizhongjiazai() {
                ss.Dictservice.listbycategory("YLCurrency").then(rd => {
                    this.bizhongListops = rd;
                })
            },
            //重新提交
            chongxintijiao() {
                if (this.isOemPrice ||  this.$route.query.hid == 'YX1' ) {
                    var canshue = [];
                    for (var t in this.tableData3) {
                        canshue.push({
                            id: this.tableData3[t].id,//定价主键id
                            leltypecode: this.tableData3[t].leixing || null,//定价类型
                            type: this.tableData3[t].jibie || null,//类型的值  级别或者区域
                            currency: this.tableData3[t].bizhong || null,//币种
                            value: this.tableData3[t].jiage || null,//定价金额
                            startdate: this.tableData3[t].startdate || null,//定价有效期开始
                            effectivedate: this.tableData3[t].effectivedate || null,//定价有效期截至
                        })
                    }
                    //先更新
                    ss.chanpin.gengxinbohuidingjia(canshue).then(rd => {
                        if (rd.obj == true) {//更新成功
                            var shenPiEntity = {
                                yewuzhujian: this.ywid,
                                taskid: this.taskid,
                                instid: this.instid,
                                xiaoe:this.zy.xiaoe,
                                jishu:this.zy.jishu,
                                factory:this.zy.factory,

                            }
                            //重新提交
                            ss.chanpin.chongxintijiaodingjia(shenPiEntity).then(rd => {
                                this.$msg.msgs(rd.msg)
                                this.$router.go(-1);
                            })
                        }
                    })
                } else {
                    this.$msg.msge("OEM产品请先联系采购经理维护采购价格后才可发起定价！");
                }
            },
            //查找驳回定价
            chazhaobohui(q) {
                ss.chanpin.chazhaobohuidingjia(q).then(rd => {
                    this.zy = rd.viewMaterialAllvw;
                    this.jiazaibiao(rd.mdmMaterialInfoPriceList);
                })
            },
            //查找定价
            query(q) {
                this.yaoshanchude = [];
                if (q.materialCode != null && q.materialCode != '') {
                    this.q.materialid = q.materialCode;
                    ss.chanpin.selectAll(this.q).then(rd => {
                        this.dingjiajihe = rd.obj;
                        this.jiazaibiao(rd.obj);
                    })
                };
                //加载所有场景类型
                ss.bom.getAllSceneList().then(rd => {
                    this.sceneList = rd.msg;
                });

            },
            //加载表
            jiazaibiao(q) {
                this.tableData3 = [];
                for (var y in q) {
                    var list = {
                        leixing: q[y].leltypecode,
                        jibie: q[y].type,//类型的值  级别或者区域
                        bizhong: q[y].currency,//币种
                        jiage: q[y].value,//定价金额
                        leixingflag: q[y].leltypecode,//类型的flag
                        effectivedate: q[y].effectivedate,
                        startdate: q[y].startdate,
                        materialid: q[y].materialid,//物料id
                        bianlianga: (q[y].leltypecode == 0 || q[y].leltypecode == '0') ? 'dj_foreign_area' : (q[y].leltypecode == 1 || q[y].leltypecode == '1') ? 'customer_group' : (q[y].leltypecode == 2 || q[y].leltypecode == '2') ? 'dj_foreign_area' : '',
                        ispass: q[y].ispass,//审核标志   0 未通过   1 通过   2暂存  3提交审核中
                        isuse: q[y].isuse,//
                        cuname: q[y].cuname,//
                        cucode: q[y].cucode,//
                        instid: q[y].instid,//
                        id: q[y].id,//定价主键id
                        shiti: q[y],//实体类
                    }

                    this.tableData3.push(list)
                    this.zy.shenpiyijian = q[0] != null ? q[0].jindu != null ? q[0].jindu.split("_")[2] : '' : '';//审批意见
                }
            },
            //更换级别区域
            changejibiequyu(q) {
                console.log(q, '哈哈后')
                this.jiazaijibiequyu(q);
            },
            //添加框
            add() {
                var list = {
                    materialid: this.chanpinneirong.materialCode,
                    leixing: '',
                    jibie: '',
                    bizhong: '',
                    jiage: '',
                    youxiaoqi: '',
                    effectivedate: '',
                    startdate: '',
                    ispass: '',
                }
                this.tableData3.push(list)
            },
            //删除框
            delPlan(index, q) {
                this.$confirm('确认删除？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                    .then(_ => {
                        //如果原来有数据
                        if (q.id != null) {//把要删除的定价主键id存起来
                            this.yaoshanchude.push(q);
                        }
                        this.tableData3.splice(index, 1)
                        //console.log(index,"删除一行数据");

                    })
                    .catch(_ => {
                    });
            },
            //提交/暂存 按钮
            dingjiaanniu(q) {
                var subflag = false;
                this.$refs['zy'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });

                if(this.zy.protype == 'OEM'){
                    if(this.zy.factory == '9370' || this.zy.factory == '9393'){
                        this.$msg.msge("OEM产品产地不允许选择9370或9393，请重新选择产地！");
                        return;
                    }
                }

                //校验是否有内销定价，如果有销额，基数，产地必填
                for (var t in this.tableData3) {
                    //如果有内销的数据 验证 销额 基数 产地 必填
                    if(this.tableData3[t].leixing=='1'){
                         if(!this.zy.xiaoe || !this.zy.jishu || !this.zy.factory){
                             this.$msg.msge("内销产品，销额，基数，产地必填！");
                             return false;
                         }
                        break;
                    }
                }

                if(q == 1){
                    //液氮罐产品定价提交时必须有UN或内销一级价（生成采购合同）
                    var flag = true;
                    if(this.$route.query.hid == 'ND1'){
                        for (var s in this.tableData3) {
                            if(this.tableData3[s].ispass == "" || this.tableData3[s].ispass == null || this.tableData3[s].ispass == '2'){
                                if(this.tableData3[s].bizhong == 'CNY' && (this.tableData3[s].jibie=='01' ||this.tableData3[s].jibie=='global' )){
                                    flag = false;
                                }
                            }
                        }
                        if(flag){
                            this.$msg.msge("由于液氮罐产品定价自动生成采购合同，所以必须有全球或内销一级人民币价格！");
                            return;
                        }
                    }

                }

                if (subflag == true) {
                    /*for (var t in this.tableData3) {
                        for (var tt in this.tableData3) {
                            if (t != tt) {
                                if (this.tableData3[t].leixing == this.tableData3[tt].leixing
                                    && (this.tableData3[t].jibie == this.tableData3[tt].jibie || this.tableData3[t].jibie == "global" || this.tableData3[tt].jibie == "global")
                                    && this.tableData3[t].bizhong == this.tableData3[tt].bizhong
                                    && (this.tableData3[t].startdate >= this.tableData3[tt].startdate
                                        && this.tableData3[t].startdate <= this.tableData3[tt].effectivedate)
                                ) {
                                    return this.$msg.msge('请先删除一条同类型重复有效期范围价格')
                                }

                            }
                        }
                    }*/

                    if (this.isOemPrice ||  this.$route.query.hid == 'YX1'  ) {
                        //如果有待删除的
                        if (this.yaoshanchude.length > 0) {
                            var chushu = '';
                            for (var c in this.yaoshanchude) {
                                for (var s in this.yaoshanchude[c].shiti) {
                                    switch (s) {

                                        case "value":
                                            chushu = chushu + "金额: " + this.yaoshanchude[c].shiti[s] + " ";
                                            break;
                                        case "currency":
                                            chushu = chushu + " 币种: " + this.yaoshanchude[c].shiti[s] + " ";
                                            break;
                                        case "startdate":
                                            chushu = chushu + " 开始时间: " + this.yaoshanchude[c].shiti[s] + " ";
                                            break;
                                        case "effectivedate":
                                            chushu = chushu + " 截至时间: " + this.yaoshanchude[c].shiti[s] + "";
                                            break;
                                    }
                                }
                            }
                            this.$confirm(chushu + ' 这些定价确认要删除？')
                                .then(_ => {
                                    //默认先删除
                                    ss.chanpin.dingjialuojishanchu(this.yaoshanchude).then(rd => {
                                        if (rd.f) {//如果删除成功的话
                                            this.yaoshanchude = [];
                                            //进入按钮
                                            this.jinruanniu(q);
                                        }
                                    })
                                })
                                .catch(_ => {
                                })
                        } else {//若没有要删除的话
                            //进入按钮
                            this.jinruanniu(q);
                        }
                    } else {
                        this.$msg.msge("OEM产品请先联系采购经理维护采购价格后才可发起定价！");
                    }
                }
            },
            jinruanniu(q) {
                if(q == 1){
                    if(this.zy.protype == "OEM" && !this.zy.unitPrice && this.zy.productClass!="耗材/散件" && this.zy.productClass!="生态-实施服务"
                        && this.$route.query.hid != 'ND1' && this.$route.query.hid != 'KS1' && this.$route.query.hid != 'HH1' && this.$route.query.hid != 'YX1'){
                        var data = {}
                        data.materialid = this.zy.materialCode
                        ss.chanpin.getHistoryMarcode(data).then(rd => {
                            if (!rd){
                                this.$msg.msge("该产品未立项，无法发起定价");
                                return false;
                            }else {
                                this.zancun(q);//暂存定价信息
                            }
                        })
                    }else {
                        this.zancun(q);//暂存定价信息
                    }
                }else {
                    this.zancun(q);//暂存定价信息
                }
            },
            //暂存定价
            zancun(q) {
                var canshu = [];
                if (this.tableData3.length > 0) {
                    for (var t in this.tableData3) {
                        canshu.push({
                            typeUserCode:this.zy.typeUserCode,
                            protype:this.zy.protype,
                            id: this.tableData3[t].id,
                            materialid: this.tableData3[t].materialid,
                            leltypecode: this.tableData3[t].leixingflag,
                            type: this.tableData3[t].jibie,
                            value: this.tableData3[t].jiage,
                            currency: this.tableData3[t].bizhong,
                            startdate: this.tableData3[t].startdate,
                            effectivedate: this.tableData3[t].effectivedate,
                            ispass: this.tableData3[t].ispass,
                            isuse: this.tableData3[t].isuse,
                            xiaoe:this.zy.xiaoe,
                            jishu:this.zy.jishu,
                            factory:this.zy.factory,
                            zancun:q,
                        })
                    }
                    console.log("canshu",canshu);
                    //暂存定价信息
                    ss.chanpin.dingjiazengjiazancun(canshu).then(rd => {
                        if (q == 1) {
                            this.qudingjia();//去发起定价审批
                        } else {
                            this.$msg.msgs(rd.msg)
                            this.fanhuizancun = rd.obj;
                            // //加载
                            this.query(this.chanpinneirong)
                        }
                    })

                }

            },
            //去定价，发定价审批  启动审批流
            qudingjia() {
                //发起提交审核定价  启动审批流
                this.faqidingjia();
            },
            //发起定价 启动审批流
            faqidingjia() {
                console.log(this.tableData3, 'tableData3')
                if (this.tableData3.length != 0) {
                    var data = {
                        materialid: this.dingjiaid,
                        xiaoe:this.zy.xiaoe,
                        jishu:this.zy.jishu,
                        factory:this.zy.factory,
                        typeUserCode:this.zy.typeUserCode,
                    }
                    ss.chanpin.gotoSetPrice(data).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.$router.go(-1);
                    })
                }
            },
            //取消
            quxiao() {
                this.$router.go(-1);
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            },
            //更换数据字典名
            jiazaijibiequyu(q) {
                if (q.leixing == 0) {
                    q.jibie = '',
                        q.bizhong = 'USD',
                        q.bianlianga = 'dj_foreign_area';
                    q.leixingflag = 0;

                }
                if (q.leixing == 1) {
                    // this.jibie = [];
                    q.jibie = '01',
                        q.bizhong = 'CNY',
                        q.bianlianga = 'customer_group';
                    q.leixingflag = 1;
                }
                if (q.leixing == 2) {
                  // this.jibie = [];
                  q.jibie = '',
                      q.bizhong = 'CNY',
                      q.bianlianga = 'dj_foreign_area';
                  q.leixingflag = 2;
                }
            },
            //检查用户是否存在
            checkUser(code){
                ss.UserService.selectById(code).then(rd => {
                    if(rd.obj==null){
                        this.$msg.msge("该型号经理在系统中不存在！");
                        this.zy.typeUserCode ='';

                    }
                })
            },
            updateData() {
                var subflag = false;
                this.$refs['zy'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    var cansgyg = {
                        materialid : this.zy.materialCode,
                        typeUserCode:this.zy.typeUserCode,
                        xiaoe:this.zy.xiaoe,
                        jishu:this.zy.jishu,
                        factory:this.zy.factory,
                    }
                    //暂存定价信息
                    ss.chanpin.updateData(cansgyg).then(rd => {
                        this.$msg.msgs(rd.msg)
                    })
                }

            },
            getchang(code) {
                this.zy.sceneCode = code;
                const scene = _.find(this.sceneList,{sceneCode:code})
                this.zy.sceneName =  scene.sceneName;

            },

        },
    }
</script>
<style>

    .weekplandetail14 .h-formbLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .weekplandetail14 .h-formbLine .el-form-item__content {
        width: 65%;
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
	.ljjtablepaddings12 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings12 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

	.ljj_selectdisblednone .el-input.is-disabled .el-input__inner{
		border-color: transparent;
	}
	.ljj_selectdisblednone.el-select .el-input.is-disabled .el-input__inner:hover{
		border-color: transparent;
	}
	.ljj_selectdisblednone .el-input__suffix{
		display: none;
	}
</style>



